import {PureComponent} from 'react'
import {Card, CardImg, CardBody, CardTitle, CardSubtitle} from 'reactstrap'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'

import Date from '../../../../../shared/components/Moment/Date.jsx'

import {generate} from '../../../../routes.js'

import './ArticleCard.scss'

export default class ArticleCard extends PureComponent {
  static propTypes = {
    article: PropTypes.object,
  }

  generateLink = () => {
    return generate({
      name: 'blog-article',
      parameters: {
        slug: this.props.article.slug
      }
    })
  }

  render() {
    const img = this.props.article?.picture?.thumbnail ?? ''
    const title = this.props.article?.title ?? ''

    return (
      <li>
        <Link to={this.generateLink()}>
          <Card className="article-sidebar-card">
            { img ? <CardImg src={img} alt={title}/> : '' }
            <CardBody>
              <CardTitle>{title}</CardTitle>
              <CardSubtitle tag="p">
                <Date format="dd/MM/yyyy" date={this.props.article?.publishing_date}/>
              </CardSubtitle>
            </CardBody>
          </Card>
        </Link>
      </li>
    )
  }
}